export const translations = {
  en: {
    nav: {
      services: "Services",
      approach: "Approach",
      ibv: "IBV",
      investors: "For Investors",
      about: "About",
      contact: "Contact",
      requestCall: "Apply for Access"
    },
    hero: {
      badge: "Active Investment Platform",
      headline: "Supporting High-Conviction",
      headlineAccent: "Entrepreneurs",
      subhead: "Structure, discipline, and execution—applied to every decision.",
      supportingLine: "Not just capital. We take an active role in building the companies we back.",
      supportingText: "",
      cta1: "Apply for Access",
      cta2: "Our Services",
      ctaSubtext: "Access is selective by design.",
      trustBullet1: "Founder-first partnerships",
      trustBullet2: "Active capital approach",
      trustBullet3: "Execution-led support",
      videoLabel: "Our Methodology",
      videoTitle: "How We Create Value",
      trustedPartner: "Trusted Partner",
      since: "Since 2026"
    },
    selectiveByDesign: {
      title: "Selective. Intentional. Aligned.",
      text: "We partner with a limited number of investors to ensure focus, alignment, and performance."
    },
    whyItMatters: {
      title: "Structured to Perform. Built to Scale.",
      text1: "Most investments don't fail due to lack of opportunity,",
      text2: "but due to lack of structure and execution.",
      text3: "We systemize both.",
      bullet1Title: "Structured Decision-Making",
      bullet1Desc: "Clear frameworks that eliminate noise and drive focused action.",
      bullet2Title: "Continuous Performance Visibility",
      bullet2Desc: "Real-time insights into portfolio health and opportunities.",
      bullet3Title: "Active Execution Support",
      bullet3Desc: "Direct involvement that accelerates results.",
      cta: "View Opportunities"
    },
    differentiation: {
      title: "Not Just Capital.",
      titleAccent: "A Structural Edge.",
      cta: "See Our Process",
      discipline: {
        title: "Investment Discipline",
        description: "Every opportunity is rigorously evaluated against clear investment criteria before consideration."
      },
      execution: {
        title: "Active Execution",
        description: "We actively support implementation, performance tracking, and value creation."
      },
      alignment: {
        title: "Aligned Incentives",
        description: "We invest alongside our partners with shared risk, shared upside, and long-term focus."
      }
    },
    vision: {
      title: "Structured to Perform. Built to Scale.",
      subtitle: "We combine capital, discipline, and execution to systematically drive performance.",
      pillar1Title: "Clarity in Decision-Making",
      pillar1Desc: "Identify constraints, define priorities, and build high-conviction decision frameworks.",
      pillar2Title: "Hands-On Value Creation",
      pillar2Desc: "Design and implement execution roadmaps with aligned incentives and operational accountability.",
      pillar3Title: "Full Performance Visibility",
      pillar3Desc: "Track performance continuously with real-time insights across growth, risks, and opportunities."
    },
    team: {
      title: "Our Team",
      member1Role: "Founder & CEO - Head of Investments",
      member2Role: "Partner & Head of Execution and Operations"
    },
    stats: {
      stat1Value: "€10M+",
      stat1Label: "Capital Deployed",
      stat2Value: "25+",
      stat2Label: "Portfolio Companies",
      stat3Value: "3x",
      stat3Label: "Average Returns",
      stat4Value: "15+",
      stat4Label: "Years Experience",
      disclaimer: "Based on selected engagements and portfolio exposure"
    },
    services: {
      badge: "Core Capabilities",
      title: "What Drives Performance",
      subtitle: "Three capabilities that directly impact investment outcomes.",
      learnMore: "Learn more",
      showLess: "Show less",
      capital: {
        title: "Capital Allocation",
        description: "Access to qualified, high-conviction opportunities backed by disciplined investment frameworks.",
        tier1Name: "1. Active Investment",
        tier1Desc: "Hands-on capital with an executive role to drive growth from within.",
        tier2Name: "2. Non-Active Investment",
        tier2Desc: "Equity investment without operational involvement, purely financial oversight.",
        tier3Name: "3. High-Level Networking",
        tier3Desc: "Access to strategic relationships, deal flow, and institutional connections to accelerate performance."
      },
      revenue: {
        title: "Revenue Growth",
        description: "Implement scalable systems that directly impact revenue, margins, and valuation.",
        tier1Name: "1. Commercial Structure",
        tier1Desc: "Building scalable sales teams, pipeline optimization, and strategic account management.",
        tier2Name: "2. Revenue Management",
        tier2Desc: "Optimizing pricing and revenue levers to maximize profitability.",
        tier3Name: "3. Operations Structure",
        tier3Desc: "Designing efficient operational frameworks that support sustainable growth."
      },
      ibv: {
        title: "Institutional Brand Valuation",
        description: "Position companies to meet institutional standards and unlock higher valuation multiples.",
        tier1Name: "1. Brand Valuation",
        tier1Desc: "Strengthening brand assets and market perception to increase overall valuation.",
        tier2Name: "2. Digital Positioning",
        tier2Desc: "Optimizing brand visibility and relevance across digital discovery channels.",
        tier3Name: "3. Institutional Scale-Up",
        tier3Desc: "Elevating brand credibility for institutional partnerships, M&A, and funding rounds."
      }
    },
    portfolio: {
      subtitle: "Current Exposure",
      title: "Curated Investment Opportunities",
      cta: "Opportunities shared upon qualification",
      sectorNote: "Sector-focused exposure across high-growth markets.",
      sectors: {
        saas: "SaaS",
        fintech: "Fintech",
        healthcare: "Healthcare",
        foodtech: "Food Tech",
        ecommerce: "E-Commerce",
        mobility: "Mobility"
      }
    },
    approach: {
      title: "A Disciplined Process",
      subtitle: "METHODOLOGY",
      step1: {
        title: "Diagnose",
        description: "Identify constraints, positioning gaps, and real growth opportunities."
      },
      step2: {
        title: "Structure",
        description: "Define a roadmap with clear milestones and aligned incentives."
      },
      step3: {
        title: "Execute",
        description: "Implement with direct involvement and continuous performance monitoring."
      }
    },
    testimonials: {
      subtitle: "Selected Case",
      title: "Performance Track Record",
      subtitleText: "Results from selected engagements.",
      testimonial1: {
        quote: "The structured approach and direct execution contributed to a significantly higher valuation outcome.",
        author: "Portfolio Company CEO",
        role: "Growth-stage SaaS",
        company: ""
      },
      testimonial2: {
        quote: "Their disciplined methodology helped us secure our Series B at a valuation 3x higher than initial projections.",
        author: "Managing Director",
        role: "Technology Sector",
        company: ""
      },
      testimonial3: {
        quote: "Enterprise contract volume doubled within 18 months through structured commercial execution.",
        author: "Chief Operating Officer",
        role: "B2B Software",
        company: ""
      }
    },
    whoThisIsFor: {
      title: "Designed for Select Investors",
      text: "Designed for investors who value structure, selectivity, and performance over volume."
    },
    investors: {
      title: "Structured Access.",
      titleAccent: "Qualified Opportunities.",
      subtitle: "FOR QUALIFIED INVESTORS",
      punchyIntro: "Performance driven by discipline, execution, and proprietary deal flow — built for investors who value clarity and long-term results.",
      types: "Investor Types",
      typesIntro: "We work selectively with qualified partners across the following profiles:",
      typesList: ["Angel Investors", "Family Offices", "Venture Capital", "Private Equity", "Strategic Partners"],
      ticket: "Typical Commitment",
      ticketRange: "€25K – €50K",
      ticketSubtitle: "Flexible structures based on opportunity and investor profile",
      ticketTransparency: "Structured per opportunity with full transparency on use of capital.",
      benefits: {
        title: "What Qualified Investors Receive",
        item1: "Qualified deal flow",
        item2: "Rigorous due diligence",
        item3: "Structured co-investment terms",
        item4: "Real-time portfolio visibility",
        item5: "Direct access to opportunities",
        item6: "Institutional reporting standards"
      },
      accessNote: "Access is granted selectively after an initial qualification.",
      cta: "Apply for Access"
    },
    clientPortal: {
      title: "Your Investments.",
      titleAccent: "Full Visibility.",
      subtitle: "Track performance, access documents, and monitor opportunities in real time.",
      feature1: "Portfolio Dashboard",
      feature2: "Document Center",
      feature3: "Deal Pipeline",
      feature4: "Notifications"
    },
    about: {
      title: "Built for Performance",
      subtitle: "ABOUT",
      mission: "Our Mission",
      missionText: "We combine capital, hands-on execution, and institutional positioning to help founders scale — and investors achieve superior, risk-adjusted outcomes.",
      values: "Operating Principles",
      value1: "Integrity in all dealings",
      value1Desc: "We operate with full transparency toward founders, investors, and partners — no conflicts, no shortcuts.",
      value2: "Excellence in execution",
      value2Desc: "Every engagement is held to institutional standards. We don't advise — we deliver.",
      value3: "Confidentiality by design",
      value3Desc: "All information shared within our platform is treated with strict discretion and structural safeguards.",
      principlesClosing: "These principles are not aspirational — they are operational."
    },
    team: {
      title: "Our Team",
      subtitle: "The people behind the capital, the strategy, and the execution.",
      member1Role: "Founder & CEO, Head of Investments",
      member1Bio: "Serial entrepreneur and investor with over 15 years building and scaling companies across Europe and Latin America. Patricio leads deal sourcing, capital structuring, and strategic partnerships.",
      member2Role: "Partner, Head of Execution and Operations",
      member2Bio: "Operations and growth specialist with deep experience in scaling commercial teams, optimizing revenue structures, and building institutional-grade processes for high-growth companies."
    },
    finalCta: {
      title: "Apply for Access",
      subtitle: "A selective process — we only partner with founders and investors where there is genuine alignment.",
      step1Title: "Submit Your Profile",
      step1Desc: "Tell us about your goals, background, and what you're looking for.",
      step2Title: "Qualification Call",
      step2Desc: "A focused conversation to assess alignment and opportunity fit.",
      step3Title: "Access Granted",
      step3Desc: "Receive curated deal flow and direct access to our network.",
      trustLine: "Applications are reviewed within 5 business days. All information is treated with strict confidentiality.",
      cta: "Apply for Access",
      noCommitment: "No commitment required. Access is selective by design."
    },
    loginModal: {
      title: "Access Your Investment Dashboard",
      subtitle: "Monitor performance, documents, and opportunities in one place."
    },
    faq: {
      subtitle: "Common Questions",
      title: "Frequently Asked Questions",
      description: "Key information for investors and partners.",
      stillQuestions: "Still have questions?",
      getInTouch: "Get in touch",
      q1: "Who is Hübner Capital for?",
      a1: "We work with two distinct groups: high-conviction founders leading scalable businesses who need more than just capital, and qualified investors looking for curated, disciplined deal flow. Both must meet our qualification criteria — we are selective by design.",
      q2: "What types of companies do you invest in?",
      a2: "We focus on companies in high-growth sectors — including SaaS, Fintech, Healthcare, Food Tech, E-Commerce, and Mobility — that have demonstrated product-market fit and are ready to scale. We look for founders with clarity of vision and the discipline to execute.",
      q3: "What does 'active investment' mean in practice?",
      a3: "Unlike passive capital providers, we take an operational role alongside the founder. This means direct involvement in commercial structure, revenue management, and institutional positioning — not board oversight from a distance, but hands-on execution with aligned incentives.",
      q4: "How does the qualification process work?",
      a4: "After submitting your profile, our team reviews your application within 5 business days. If there is potential alignment, we schedule a focused qualification call. Access to opportunities and partnership structures is granted only after this process is complete. All information is treated with strict confidentiality.",
      q5: "What is Institutional Brand Valuation (IBV) and why does it matter?",
      a5: "IBV is our proprietary framework for positioning companies to meet institutional standards — strengthening brand credibility, digital visibility, and market perception in ways that directly impact valuation multiples. It bridges the gap between a strong business and an investable one.",
      q6: "I'm an investor — what can I expect after being qualified?",
      a6: "Qualified investors receive access to curated deal flow that has passed our internal due diligence process, structured co-investment terms, real-time portfolio visibility, and institutional reporting standards. You will not receive unsolicited opportunities — everything is matched to your profile and preferences.",
      q7: "Is there a minimum commitment required?",
      a7: "Typical commitments range based on opportunity and investor profile. Structures are flexible and designed around alignment — not arbitrary thresholds. This is discussed during the qualification process."
    },
    contact: {
      title: "Let's Connect",
      subtitle: "GET IN TOUCH",
      tabInvestor: "I'm an Investor",
      tabCompany: "I'm a Company / Founder",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        country: "Country / Region",
        language: "Preferred Language",
        linkedin: "LinkedIn URL",
        company: "Company / Organization",
        role: "Role / Title",
        message: "Message / Notes",
        investorType: "Investor Type",
        investmentFocus: "Investment Focus",
        ticketSize: "Typical Ticket Size",
        investmentRange: "Investment Range for This Opportunity",
        sectors: "Sector Preferences",
        geography: "Geography Preference",
        timeHorizon: "Time Horizon",
        companyWebsite: "Company Website",
        revenue: "Annual Revenue Range",
        teamSize: "Team Size",
        objective: "Primary Objective",
        timeline: "Desired Timeline",
        budget: "Budget / Engagement Size",
        consent: "I consent to be contacted regarding this inquiry",
        privacy: "By submitting this form, you agree to our Privacy Policy and Terms of Service.",
        submit: "Submit Inquiry",
        submitting: "Submitting...",
        successTitle: "Thank You",
        successMessage: "Your inquiry has been received. We will be in touch shortly.",
        bookCall: "Book a Call"
      }
    },
    footer: {
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  },
  "es-es": {
    nav: { services: "Servicios", approach: "Enfoque", ibv: "IBV", investors: "Inversores", about: "Nosotros", contact: "Contacto", requestCall: "Solicitar Acceso" },
    hero: { 
      badge: "Plataforma de Inversión Activa",
      headline: "Apoyando Emprendedores",
      headlineAccent: "de Alta Convicción",
      subhead: "Estructura, disciplina y ejecución—aplicados a cada decisión.",
      supportingLine: "No solo capital. Tomamos un rol activo en la construcción de las empresas que respaldamos.",
      supportingText: "",
      cta1: "Solicitar Acceso",
      cta2: "Nuestros Servicios",
      ctaSubtext: "El acceso es selectivo por diseño.",
      trustBullet1: "Colaboraciones centradas en el fundador",
      trustBullet2: "Enfoque de capital activo",
      trustBullet3: "Soporte orientado a la ejecución",
      videoLabel: "Nuestra Metodología",
      videoTitle: "Cómo Creamos Valor",
      trustedPartner: "Socio de Confianza",
      since: "Desde 2026"
    },
    selectiveByDesign: {
      title: "Selectivos. Intencionales. Alineados.",
      text: "Colaboramos con un número limitado de inversores para garantizar enfoque, alineación y rendimiento."
    },
    whyItMatters: {
      title: "Estructurados para Rendir. Construidos para Escalar.",
      text1: "La mayoría de las inversiones no fracasan por falta de oportunidad,",
      text2: "sino por falta de estructura y ejecución.",
      text3: "Nosotros sistematizamos ambas.",
      bullet1Title: "Toma de Decisiones Estructurada",
      bullet1Desc: "Frameworks claros que eliminan el ruido y guían acciones enfocadas.",
      bullet2Title: "Visibilidad Continua del Rendimiento",
      bullet2Desc: "Insights en tiempo real sobre la salud del portfolio y las oportunidades.",
      bullet3Title: "Soporte Activo en la Ejecución",
      bullet3Desc: "Involucramiento directo que acelera resultados."
    },
    differentiation: {
      title: "No Solo Capital.",
      titleAccent: "Una Ventaja Estructural.",
      cta: "Ver Nuestro Proceso",
      discipline: {
        title: "Disciplina de Inversión",
        description: "Cada oportunidad es evaluada rigurosamente contra criterios de inversión claros antes de ser considerada."
      },
      execution: {
        title: "Ejecución Activa",
        description: "Apoyamos activamente la implementación, el seguimiento del rendimiento y la creación de valor."
      },
      alignment: {
        title: "Incentivos Alineados",
        description: "Invertimos junto a nuestros socios con riesgo compartido, upside compartido y enfoque a largo plazo."
      }
    },
    vision: {
      title: "Estructurados para Rendir. Construidos para Escalar.",
      subtitle: "Combinamos capital, disciplina y ejecución para impulsar sistemáticamente el rendimiento.",
      pillar1Title: "Claridad en las Decisiones",
      pillar1Desc: "Identificar restricciones, definir prioridades y construir frameworks de decisión de alta convicción.",
      pillar2Title: "Creación de Valor Operativa",
      pillar2Desc: "Diseñar e implementar hojas de ruta de ejecución con incentivos alineados y responsabilidad operativa.",
      pillar3Title: "Visibilidad Total del Rendimiento",
      pillar3Desc: "Monitorear el rendimiento continuamente con insights en tiempo real sobre crecimiento, riesgos y oportunidades."
    },
    team: {
      title: "Nuestro Equipo",
      subtitle: "Las personas detrás del capital, la estrategia y la ejecución.",
      member1Role: "Fundador & CEO, Director de Inversiones",
      member1Bio: "Emprendedor serial e inversor con más de 15 años construyendo y escalando empresas en Europa y América Latina. Patricio lidera deal sourcing, estructuración de capital y partnerships estratégicas.",
      member2Role: "Socio, Director de Ejecución y Operaciones",
      member2Bio: "Especialista en operaciones y crecimiento con amplia experiencia en escalar equipos comerciales, optimizar estructuras de revenue y construir procesos de nivel institucional para empresas de alto crecimiento."
    },
    stats: {
      stat1Value: "€10M+",
      stat1Label: "Capital Desplegado",
      stat2Value: "25+",
      stat2Label: "Empresas en Portfolio",
      stat3Value: "3x",
      stat3Label: "Retornos Promedio",
      stat4Value: "15+",
      stat4Label: "Años de Experiencia",
      disclaimer: "Basado en engagements seleccionados y exposición de portfolio"
    },
    services: {
      badge: "Capacidades Core",
      title: "Qué Impulsa el Rendimiento",
      subtitle: "Tres capacidades que impactan directamente los resultados de inversión.",
      learnMore: "Saber más",
      showLess: "Mostrar menos",
      capital: {
        title: "Asignación de Capital",
        description: "Acceso a oportunidades cualificadas de alta convicción, respaldadas por frameworks de inversión disciplinados.",
        tier1Name: "1. Inversión Activa",
        tier1Desc: "Capital con rol ejecutivo directo para impulsar el crecimiento desde dentro.",
        tier2Name: "2. Inversión No Activa",
        tier2Desc: "Inversión en equity sin involucramiento operativo, supervisión puramente financiera.",
        tier3Name: "3. Networking de Alto Nivel",
        tier3Desc: "Acceso a relaciones estratégicas, deal flow y conexiones institucionales para acelerar el rendimiento."
      },
      revenue: {
        title: "Crecimiento de Ingresos",
        description: "Implementamos sistemas escalables que impactan directamente ingresos, márgenes y valoración.",
        tier1Name: "1. Estructura Comercial",
        tier1Desc: "Construcción de equipos de ventas escalables, optimización de pipeline y gestión estratégica de cuentas.",
        tier2Name: "2. Revenue Management",
        tier2Desc: "Optimización de pricing y palancas de revenue para maximizar rentabilidad.",
        tier3Name: "3. Estructura Operativa",
        tier3Desc: "Diseño de frameworks operativos eficientes que soportan crecimiento sostenible."
      },
      ibv: {
        title: "Valoración Institucional de Marca",
        description: "Posicionamos empresas para cumplir estándares institucionales y desbloquear múltiplos de valoración más altos.",
        tier1Name: "1. Valoración de Marca",
        tier1Desc: "Fortalecimiento de activos de marca y percepción de mercado para aumentar la valoración general.",
        tier2Name: "2. Posicionamiento Digital",
        tier2Desc: "Optimización de la visibilidad y relevancia de marca en canales digitales.",
        tier3Name: "3. Scale-Up Institucional",
        tier3Desc: "Elevar la credibilidad de marca para partnerships institucionales, M&A y rondas de financiación."
      }
    },
    portfolio: {
      subtitle: "Exposición Actual",
      title: "Oportunidades de Inversión Seleccionadas",
      cta: "Oportunidades compartidas tras cualificación",
      sectorNote: "Exposición sectorial en mercados de alto crecimiento.",
      sectors: {
        saas: "SaaS",
        fintech: "Fintech",
        healthcare: "Healthcare",
        foodtech: "Food Tech",
        ecommerce: "E-Commerce",
        mobility: "Movilidad"
      }
    },
    approach: {
      title: "Un Proceso Disciplinado",
      subtitle: "METODOLOGÍA",
      step1: { title: "Diagnosticar", description: "Identificar restricciones, gaps de posicionamiento y oportunidades reales de crecimiento." },
      step2: { title: "Estructurar", description: "Definir una hoja de ruta con hitos claros e incentivos alineados." },
      step3: { title: "Ejecutar", description: "Implementar con involucramiento directo y monitoreo continuo del rendimiento." }
    },
    testimonials: {
      subtitle: "Caso Seleccionado",
      title: "Track Record de Rendimiento",
      subtitleText: "Resultados de engagements seleccionados.",
      testimonial1: {
        quote: "El enfoque estructurado y la ejecución directa contribuyeron a un resultado de valoración significativamente superior.",
        author: "CEO Empresa del Portfolio",
        role: "SaaS Growth-stage",
        company: ""
      },
      testimonial2: {
        quote: "La metodología disciplinada nos ayudó a cerrar la Serie B con una valoración 3x superior a las proyecciones iniciales.",
        author: "Managing Director",
        role: "Sector Tecnología",
        company: ""
      },
      testimonial3: {
        quote: "El volumen de contratos enterprise se duplicó en 18 meses a través de ejecución comercial estructurada.",
        author: "Chief Operating Officer",
        role: "Software B2B",
        company: ""
      }
    },
    whoThisIsFor: {
      title: "Diseñado para Inversores Selectos",
      text: "Diseñado para inversores que valoran estructura, selectividad y rendimiento sobre volumen."
    },
    investors: {
      title: "Acceso Estructurado.",
      titleAccent: "Oportunidades Cualificadas.",
      subtitle: "PARA INVERSORES CUALIFICADOS",
      punchyIntro: "Rendimiento impulsado por disciplina, ejecución y deal flow propietario — construido para inversores que valoran claridad y resultados a largo plazo.",
      types: "Tipos de Inversores",
      typesIntro: "Trabajamos selectivamente con socios cualificados en los siguientes perfiles:",
      typesList: ["Inversores Ángeles", "Family Offices", "Venture Capital", "Private Equity", "Socios Estratégicos"],
      ticket: "Compromiso Típico",
      ticketRange: "€25K – €50K",
      ticketSubtitle: "Estructuras flexibles según oportunidad y perfil del inversor",
      ticketTransparency: "Estructurado por oportunidad con total transparencia sobre el uso del capital.",
      benefits: { 
        title: "Qué Reciben los Inversores Cualificados", 
        item1: "Deal flow cualificado", 
        item2: "Due diligence rigurosa", 
        item3: "Términos de co-inversión estructurados",
        item4: "Visibilidad del portfolio en tiempo real",
        item5: "Acceso directo a oportunidades",
        item6: "Estándares de reporting institucional"
      },
      accessNote: "El acceso se concede selectivamente tras una cualificación inicial.",
      cta: "Solicitar Acceso"
    },
    clientPortal: {
      title: "Tus Inversiones.",
      titleAccent: "Visibilidad Total.",
      subtitle: "Monitorea rendimiento, accede a documentos y sigue oportunidades en tiempo real.",
      feature1: "Dashboard de Portfolio",
      feature2: "Centro de Documentos",
      feature3: "Pipeline de Deals",
      feature4: "Notificaciones"
    },
    about: {
      title: "Construidos para el Rendimiento",
      subtitle: "NOSOTROS",
      mission: "Nuestra Misión",
      missionText: "Combinamos capital, ejecución operativa y posicionamiento institucional para ayudar a los founders a escalar — y a los inversores a lograr resultados superiores, ajustados al riesgo.",
      values: "Principios Operativos",
      value1: "Integridad en todas las relaciones",
      value1Desc: "Operamos con total transparencia hacia founders, inversores y socios — sin conflictos, sin atajos.",
      value2: "Excelencia en la ejecución",
      value2Desc: "Cada engagement se mantiene a estándares institucionales. No aconsejamos — entregamos.",
      value3: "Confidencialidad por diseño",
      value3Desc: "Toda la información compartida en nuestra plataforma se trata con estricta discreción y salvaguardas estructurales.",
      principlesClosing: "Estos principios no son aspiracionales — son operativos."
    },
    finalCta: {
      title: "Solicitar Acceso",
      subtitle: "Un proceso selectivo — solo colaboramos con founders e inversores donde hay alineación genuina.",
      step1Title: "Envía Tu Perfil",
      step1Desc: "Cuéntanos sobre tus objetivos, background y qué estás buscando.",
      step2Title: "Llamada de Cualificación",
      step2Desc: "Una conversación enfocada para evaluar alineación y fit de oportunidad.",
      step3Title: "Acceso Concedido",
      step3Desc: "Recibe deal flow curado y acceso directo a nuestra red.",
      trustLine: "Las solicitudes se revisan en 5 días hábiles. Toda la información se trata con estricta confidencialidad.",
      cta: "Solicitar Acceso",
      noCommitment: "Sin compromiso requerido. El acceso es selectivo por diseño."
    },
    faq: {
      subtitle: "Preguntas Frecuentes",
      title: "FAQ",
      description: "Todo lo que necesitas saber para colaborar con HÜBNER Capital.",
      stillQuestions: "¿Aún tienes preguntas?",
      getInTouch: "Contáctanos",
      q1: "¿Para quién es Hübner Capital?",
      a1: "Trabajamos con dos grupos distintos: founders de alta convicción que lideran negocios escalables y necesitan más que solo capital, e inversores cualificados buscando deal flow curado y disciplinado. Ambos deben cumplir nuestros criterios de cualificación — somos selectivos por diseño.",
      q2: "¿En qué tipos de empresas invierten?",
      a2: "Nos enfocamos en empresas en sectores de alto crecimiento — incluyendo SaaS, Fintech, Healthcare, Food Tech, E-Commerce y Movilidad — que han demostrado product-market fit y están listas para escalar. Buscamos founders con claridad de visión y disciplina en la ejecución.",
      q3: "¿Qué significa 'inversión activa' en la práctica?",
      a3: "A diferencia de los proveedores de capital pasivo, asumimos un rol operativo junto al founder. Esto significa involucramiento directo en estructura comercial, revenue management y posicionamiento institucional — no supervisión desde el board a distancia, sino ejecución hands-on con incentivos alineados.",
      q4: "¿Cómo funciona el proceso de cualificación?",
      a4: "Después de enviar tu perfil, nuestro equipo revisa la solicitud en 5 días hábiles. Si hay potencial alineación, programamos una llamada de cualificación enfocada. El acceso a oportunidades y estructuras de partnership se concede solo después de completar este proceso. Toda la información se trata con estricta confidencialidad.",
      q5: "¿Qué es la Valoración Institucional de Marca (IBV) y por qué importa?",
      a5: "IBV es nuestro framework propietario para posicionar empresas según estándares institucionales — fortaleciendo credibilidad de marca, visibilidad digital y percepción de mercado de formas que impactan directamente los múltiplos de valoración. Cierra la brecha entre un negocio fuerte y uno invertible.",
      q6: "Soy inversor — ¿qué puedo esperar después de la cualificación?",
      a6: "Los inversores cualificados reciben acceso a deal flow curado que ha pasado nuestro proceso interno de due diligence, términos de co-inversión estructurados, visibilidad del portfolio en tiempo real y estándares de reporting institucional. No recibirás oportunidades no solicitadas — todo se adapta a tu perfil y preferencias.",
      q7: "¿Se requiere un compromiso mínimo?",
      a7: "Los compromisos típicos varían según la oportunidad y el perfil del inversor. Las estructuras son flexibles y diseñadas en torno a la alineación — no a umbrales arbitrarios. Esto se discute durante el proceso de cualificación."
    },
    contact: {
      title: "Conectemos",
      subtitle: "CONTACTO",
      tabInvestor: "Soy Inversor",
      tabCompany: "Soy Empresa / Founder",
      form: {
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Email",
        phone: "Teléfono",
        country: "País / Región",
        language: "Idioma Preferido",
        linkedin: "URL de LinkedIn",
        company: "Empresa / Organización",
        role: "Cargo / Título",
        message: "Mensaje / Notas",
        investorType: "Tipo de Inversor",
        investmentFocus: "Foco de Inversión",
        ticketSize: "Ticket Size Típico",
        investmentRange: "Rango de Inversión para esta Oportunidad",
        sectors: "Preferencias de Sector",
        geography: "Preferencia Geográfica",
        timeHorizon: "Horizonte Temporal",
        companyWebsite: "Sitio Web de la Empresa",
        revenue: "Rango de Facturación Anual",
        teamSize: "Tamaño del Equipo",
        objective: "Objetivo Principal",
        timeline: "Timeline Deseado",
        budget: "Presupuesto / Tamaño del Engagement",
        consent: "Consiento ser contactado respecto a esta consulta",
        privacy: "Al enviar este formulario, aceptas nuestra Política de Privacidad y Términos de Servicio.",
        submit: "Enviar Consulta",
        submitting: "Enviando...",
        successTitle: "Gracias",
        successMessage: "Tu consulta ha sido recibida. Te contactaremos pronto.",
        bookCall: "Reservar Llamada"
      }
    },
    footer: { rights: "Todos los derechos reservados.", privacy: "Política de Privacidad", terms: "Términos de Servicio" },
    loginModal: {
      title: "Accede a Tu Dashboard de Inversiones",
      subtitle: "Monitorea rendimiento, documentos y oportunidades en un solo lugar."
    }
  },
  "es-latam": {
    nav: { services: "Servicios", approach: "Enfoque", ibv: "IBV", investors: "Inversores", about: "Nosotros", contact: "Contacto", requestCall: "Solicitar Acceso" },
    hero: { 
      badge: "Plataforma de Inversión Activa",
      headline: "Apoyando Emprendedores",
      headlineAccent: "de Alta Convicción",
      subhead: "Estructura, disciplina y ejecución—aplicados a cada decisión.",
      supportingLine: "No solo capital. Tomamos un rol activo en la construcción de las empresas que respaldamos.",
      supportingText: "",
      cta1: "Solicitar Acceso",
      cta2: "Nuestros Servicios",
      ctaSubtext: "El acceso es selectivo por diseño.",
      trustBullet1: "Colaboraciones centradas en el fundador",
      trustBullet2: "Enfoque de capital activo",
      trustBullet3: "Soporte orientado a la ejecución",
      videoLabel: "Nuestra Metodología",
      videoTitle: "Cómo Creamos Valor",
      trustedPartner: "Socio de Confianza",
      since: "Desde 2026"
    },
    selectiveByDesign: {
      title: "Selectivos. Intencionales. Alineados.",
      text: "Colaboramos con un número limitado de inversores para garantizar enfoque, alineación y rendimiento."
    },
    whyItMatters: {
      title: "Estructurados para Rendir. Construidos para Escalar.",
      text1: "La mayoría de las inversiones no fracasan por falta de oportunidad,",
      text2: "sino por falta de estructura y ejecución.",
      text3: "Nosotros sistematizamos ambas.",
      bullet1Title: "Toma de Decisiones Estructurada",
      bullet1Desc: "Frameworks claros que eliminan el ruido y guían acciones enfocadas.",
      bullet2Title: "Visibilidad Continua del Rendimiento",
      bullet2Desc: "Insights en tiempo real sobre la salud del portfolio y las oportunidades.",
      bullet3Title: "Soporte Activo en la Ejecución",
      bullet3Desc: "Involucramiento directo que acelera resultados."
    },
    differentiation: {
      title: "No Solo Capital.",
      titleAccent: "Una Ventaja Estructural.",
      cta: "Ver Nuestro Proceso",
      discipline: {
        title: "Disciplina de Inversión",
        description: "Cada oportunidad es evaluada rigurosamente contra criterios de inversión claros antes de ser considerada."
      },
      execution: {
        title: "Ejecución Activa",
        description: "Apoyamos activamente la implementación, el seguimiento del rendimiento y la creación de valor."
      },
      alignment: {
        title: "Incentivos Alineados",
        description: "Invertimos junto a nuestros socios con riesgo compartido, upside compartido y enfoque a largo plazo."
      }
    },
    vision: {
      title: "Estructurados para Rendir. Construidos para Escalar.",
      subtitle: "Combinamos capital, disciplina y ejecución para impulsar sistemáticamente el rendimiento.",
      pillar1Title: "Claridad en las Decisiones",
      pillar1Desc: "Identificar restricciones, definir prioridades y construir frameworks de decisión de alta convicción.",
      pillar2Title: "Creación de Valor Operativa",
      pillar2Desc: "Diseñar e implementar hojas de ruta de ejecución con incentivos alineados y responsabilidad operativa.",
      pillar3Title: "Visibilidad Total del Rendimiento",
      pillar3Desc: "Monitorear el rendimiento continuamente con insights en tiempo real sobre crecimiento, riesgos y oportunidades."
    },
    team: {
      title: "Nuestro Equipo",
      subtitle: "Las personas detrás del capital, la estrategia y la ejecución.",
      member1Role: "Fundador & CEO, Director de Inversiones",
      member1Bio: "Emprendedor serial e inversor con más de 15 años construyendo y escalando empresas en Europa y Latinoamérica. Patricio lidera deal sourcing, estructuración de capital y partnerships estratégicas.",
      member2Role: "Socio, Director de Ejecución y Operaciones",
      member2Bio: "Especialista en operaciones y crecimiento con amplia experiencia en escalar equipos comerciales, optimizar estructuras de revenue y construir procesos de nivel institucional para empresas de alto crecimiento."
    },
    stats: {
      stat1Value: "€10M+",
      stat1Label: "Capital Desplegado",
      stat2Value: "25+",
      stat2Label: "Empresas en Portfolio",
      stat3Value: "3x",
      stat3Label: "Retornos Promedio",
      stat4Value: "15+",
      stat4Label: "Años de Experiencia",
      disclaimer: "Basado en engagements seleccionados y exposición de portfolio"
    },
    services: {
      badge: "Capacidades Core",
      title: "Qué Impulsa el Rendimiento",
      subtitle: "Tres capacidades que impactan directamente los resultados de inversión.",
      learnMore: "Saber más",
      showLess: "Mostrar menos",
      capital: {
        title: "Asignación de Capital",
        description: "Acceso a oportunidades calificadas de alta convicción, respaldadas por frameworks de inversión disciplinados.",
        tier1Name: "1. Inversión Activa",
        tier1Desc: "Capital con rol ejecutivo directo para impulsar el crecimiento desde adentro.",
        tier2Name: "2. Inversión No Activa",
        tier2Desc: "Inversión en equity sin involucramiento operativo, supervisión puramente financiera.",
        tier3Name: "3. Networking de Alto Nivel",
        tier3Desc: "Acceso a relaciones estratégicas, deal flow y conexiones institucionales para acelerar el rendimiento."
      },
      revenue: {
        title: "Crecimiento de Ingresos",
        description: "Implementamos sistemas escalables que impactan directamente ingresos, márgenes y valuación.",
        tier1Name: "1. Estructura Comercial",
        tier1Desc: "Construcción de equipos de ventas escalables, optimización de pipeline y gestión estratégica de cuentas.",
        tier2Name: "2. Revenue Management",
        tier2Desc: "Optimización de pricing y palancas de revenue para maximizar rentabilidad.",
        tier3Name: "3. Estructura Operativa",
        tier3Desc: "Diseño de frameworks operativos eficientes que soportan crecimiento sostenible."
      },
      ibv: {
        title: "Valuación Institucional de Marca",
        description: "Posicionamos empresas para cumplir estándares institucionales y desbloquear múltiplos de valuación más altos.",
        tier1Name: "1. Valuación de Marca",
        tier1Desc: "Fortalecimiento de activos de marca y percepción de mercado para aumentar la valuación general.",
        tier2Name: "2. Posicionamiento Digital",
        tier2Desc: "Optimización de la visibilidad y relevancia de marca en canales digitales.",
        tier3Name: "3. Scale-Up Institucional",
        tier3Desc: "Elevar la credibilidad de marca para partnerships institucionales, M&A y rondas de financiamiento."
      }
    },
    portfolio: {
      subtitle: "Exposición Actual",
      title: "Oportunidades de Inversión Seleccionadas",
      cta: "Oportunidades compartidas tras calificación",
      sectorNote: "Exposición sectorial en mercados de alto crecimiento.",
      sectors: {
        saas: "SaaS",
        fintech: "Fintech",
        healthcare: "Healthcare",
        foodtech: "Food Tech",
        ecommerce: "E-Commerce",
        mobility: "Movilidad"
      }
    },
    approach: {
      title: "Un Proceso Disciplinado",
      subtitle: "METODOLOGÍA",
      step1: { title: "Diagnosticar", description: "Identificar restricciones, gaps de posicionamiento y oportunidades reales de crecimiento." },
      step2: { title: "Estructurar", description: "Definir una hoja de ruta con hitos claros e incentivos alineados." },
      step3: { title: "Ejecutar", description: "Implementar con involucramiento directo y monitoreo continuo del rendimiento." }
    },
    testimonials: {
      subtitle: "Caso Seleccionado",
      title: "Track Record de Rendimiento",
      subtitleText: "Resultados de engagements seleccionados.",
      testimonial1: {
        quote: "El enfoque estructurado y la ejecución directa contribuyeron a un resultado de valuación significativamente superior.",
        author: "CEO Empresa del Portfolio",
        role: "SaaS Growth-stage",
        company: ""
      },
      testimonial2: {
        quote: "La metodología disciplinada nos ayudó a cerrar la Serie B con una valuación 3x superior a las proyecciones iniciales.",
        author: "Managing Director",
        role: "Sector Tecnología",
        company: ""
      },
      testimonial3: {
        quote: "El volumen de contratos enterprise se duplicó en 18 meses a través de ejecución comercial estructurada.",
        author: "Chief Operating Officer",
        role: "Software B2B",
        company: ""
      }
    },
    whoThisIsFor: {
      title: "Diseñado para Inversores Selectos",
      text: "Diseñado para inversores que valoran estructura, selectividad y rendimiento sobre volumen."
    },
    investors: {
      title: "Acceso Estructurado.",
      titleAccent: "Oportunidades Calificadas.",
      subtitle: "PARA INVERSORES CALIFICADOS",
      punchyIntro: "Rendimiento impulsado por disciplina, ejecución y deal flow propietario — construido para inversores que valoran claridad y resultados a largo plazo.",
      types: "Tipos de Inversores",
      typesIntro: "Trabajamos selectivamente con socios calificados en los siguientes perfiles:",
      typesList: ["Inversores Ángeles", "Family Offices", "Venture Capital", "Private Equity", "Socios Estratégicos"],
      ticket: "Compromiso Típico",
      ticketRange: "€25K – €50K",
      ticketSubtitle: "Estructuras flexibles según oportunidad y perfil del inversor",
      ticketTransparency: "Estructurado por oportunidad con total transparencia sobre el uso del capital.",
      benefits: { 
        title: "Qué Reciben los Inversores Calificados", 
        item1: "Deal flow calificado", 
        item2: "Due diligence rigurosa", 
        item3: "Términos de co-inversión estructurados",
        item4: "Visibilidad del portfolio en tiempo real",
        item5: "Acceso directo a oportunidades",
        item6: "Estándares de reporting institucional"
      },
      accessNote: "El acceso se concede selectivamente tras una calificación inicial.",
      cta: "Solicitar Acceso"
    },
    clientPortal: {
      title: "Tus Inversiones.",
      titleAccent: "Visibilidad Total.",
      subtitle: "Monitorea rendimiento, accede a documentos y sigue oportunidades en tiempo real.",
      feature1: "Dashboard de Portfolio",
      feature2: "Centro de Documentos",
      feature3: "Pipeline de Deals",
      feature4: "Notificaciones"
    },
    about: {
      title: "Construidos para el Rendimiento",
      subtitle: "NOSOTROS",
      mission: "Nuestra Misión",
      missionText: "Combinamos capital, ejecución operativa y posicionamiento institucional para ayudar a los founders a escalar — y a los inversores a lograr resultados superiores, ajustados al riesgo.",
      values: "Principios Operativos",
      value1: "Integridad en todas las relaciones",
      value1Desc: "Operamos con total transparencia hacia founders, inversores y socios — sin conflictos, sin atajos.",
      value2: "Excelencia en la ejecución",
      value2Desc: "Cada engagement se mantiene a estándares institucionales. No aconsejamos — entregamos.",
      value3: "Confidencialidad por diseño",
      value3Desc: "Toda la información compartida en nuestra plataforma se trata con estricta discreción y salvaguardas estructurales.",
      principlesClosing: "Estos principios no son aspiracionales — son operativos."
    },
    finalCta: {
      title: "Solicitar Acceso",
      subtitle: "Un proceso selectivo — solo colaboramos con founders e inversores donde hay alineación genuina.",
      step1Title: "Envía Tu Perfil",
      step1Desc: "Cuéntanos sobre tus objetivos, background y qué estás buscando.",
      step2Title: "Llamada de Calificación",
      step2Desc: "Una conversación enfocada para evaluar alineación y fit de oportunidad.",
      step3Title: "Acceso Concedido",
      step3Desc: "Recibe deal flow curado y acceso directo a nuestra red.",
      trustLine: "Las solicitudes se revisan en 5 días hábiles. Toda la información se trata con estricta confidencialidad.",
      cta: "Solicitar Acceso",
      noCommitment: "Sin compromiso requerido. El acceso es selectivo por diseño."
    },
    faq: {
      subtitle: "Preguntas Frecuentes",
      title: "FAQ",
      description: "Todo lo que necesitas saber para colaborar con HÜBNER Capital.",
      stillQuestions: "¿Aún tienes preguntas?",
      getInTouch: "Contáctanos",
      q1: "¿Para quién es Hübner Capital?",
      a1: "Trabajamos con dos grupos distintos: founders de alta convicción que lideran negocios escalables y necesitan más que solo capital, e inversores calificados buscando deal flow curado y disciplinado. Ambos deben cumplir nuestros criterios de calificación — somos selectivos por diseño.",
      q2: "¿En qué tipos de empresas invierten?",
      a2: "Nos enfocamos en empresas en sectores de alto crecimiento — incluyendo SaaS, Fintech, Healthcare, Food Tech, E-Commerce y Movilidad — que han demostrado product-market fit y están listas para escalar. Buscamos founders con claridad de visión y disciplina en la ejecución.",
      q3: "¿Qué significa 'inversión activa' en la práctica?",
      a3: "A diferencia de los proveedores de capital pasivo, asumimos un rol operativo junto al founder. Esto significa involucramiento directo en estructura comercial, revenue management y posicionamiento institucional — no supervisión desde el board a distancia, sino ejecución hands-on con incentivos alineados.",
      q4: "¿Cómo funciona el proceso de calificación?",
      a4: "Después de enviar tu perfil, nuestro equipo revisa la solicitud en 5 días hábiles. Si hay potencial alineación, programamos una llamada de calificación enfocada. El acceso a oportunidades y estructuras de partnership se concede solo después de completar este proceso. Toda la información se trata con estricta confidencialidad.",
      q5: "¿Qué es la Valuación Institucional de Marca (IBV) y por qué importa?",
      a5: "IBV es nuestro framework propietario para posicionar empresas según estándares institucionales — fortaleciendo credibilidad de marca, visibilidad digital y percepción de mercado de formas que impactan directamente los múltiplos de valuación. Cierra la brecha entre un negocio fuerte y uno invertible.",
      q6: "Soy inversor — ¿qué puedo esperar después de la calificación?",
      a6: "Los inversores calificados reciben acceso a deal flow curado que ha pasado nuestro proceso interno de due diligence, términos de co-inversión estructurados, visibilidad del portfolio en tiempo real y estándares de reporting institucional. No recibirás oportunidades no solicitadas — todo se adapta a tu perfil y preferencias.",
      q7: "¿Se requiere un compromiso mínimo?",
      a7: "Los compromisos típicos varían según la oportunidad y el perfil del inversor. Las estructuras son flexibles y diseñadas en torno a la alineación — no a umbrales arbitrarios. Esto se discute durante el proceso de calificación."
    },
    contact: {
      title: "Conectemos",
      subtitle: "CONTACTO",
      tabInvestor: "Soy Inversor",
      tabCompany: "Soy Empresa / Founder",
      form: {
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Email",
        phone: "Teléfono",
        country: "País / Región",
        language: "Idioma Preferido",
        linkedin: "URL de LinkedIn",
        company: "Empresa / Organización",
        role: "Cargo / Título",
        message: "Mensaje / Notas",
        investorType: "Tipo de Inversor",
        investmentFocus: "Foco de Inversión",
        ticketSize: "Ticket Size Típico",
        investmentRange: "Rango de Inversión para esta Oportunidad",
        sectors: "Preferencias de Sector",
        geography: "Preferencia Geográfica",
        timeHorizon: "Horizonte Temporal",
        companyWebsite: "Sitio Web de la Empresa",
        revenue: "Rango de Facturación Anual",
        teamSize: "Tamaño del Equipo",
        objective: "Objetivo Principal",
        timeline: "Timeline Deseado",
        budget: "Presupuesto / Tamaño del Engagement",
        consent: "Consiento ser contactado respecto a esta consulta",
        privacy: "Al enviar este formulario, aceptas nuestra Política de Privacidad y Términos de Servicio.",
        submit: "Enviar Consulta",
        submitting: "Enviando...",
        successTitle: "Gracias",
        successMessage: "Tu consulta ha sido recibida. Te contactaremos pronto.",
        bookCall: "Agendar Llamada"
      }
    },
    footer: { rights: "Todos los derechos reservados.", privacy: "Política de Privacidad", terms: "Términos de Servicio" },
    loginModal: {
      title: "Accede a Tu Dashboard de Inversiones",
      subtitle: "Monitorea rendimiento, documentos y oportunidades en un solo lugar."
    }
  },
  "pt-pt": {
    nav: { services: "Servicos", approach: "Abordagem", ibv: "IBV", investors: "Investidores", about: "Sobre", contact: "Contacto", requestCall: "Solicitar Chamada" },
    hero: { headline: "Impulsionando o Crescimento", subhead: "Alocacao de capital, aceleracao de receitas e avaliacao institucional de marca.", cta1: "Fale Connosco", cta2: "Ver Servicos", trust1: "Liderado por operadores", trust2: "Grau institucional", trust3: "Confidencial e seletivo" }
  },
  "pt-br": {
    nav: { services: "Servicos", approach: "Abordagem", ibv: "IBV", investors: "Investidores", about: "Sobre", contact: "Contato", requestCall: "Solicitar Ligacao" },
    hero: { headline: "Impulsionando o Crescimento", subhead: "Alocacao de capital, aceleracao de receitas e avaliacao institucional de marca.", cta1: "Fale Conosco", cta2: "Ver Servicos", trust1: "Liderado por operadores", trust2: "Grau institucional", trust3: "Confidencial e seletivo" }
  },
  fr: {
    nav: { services: "Services", approach: "Approche", ibv: "IBV", investors: "Investisseurs", about: "A propos", contact: "Contact", requestCall: "Demander un Appel" },
    hero: { headline: "Alimenter la Croissance", subhead: "Allocation de capital, acceleration des revenus et valorisation institutionnelle de marque.", cta1: "Parlons", cta2: "Voir Services", trust1: "Dirige par des operateurs", trust2: "Qualite institutionnelle", trust3: "Confidentiel et selectif" }
  },
  de: {
    nav: { services: "Dienstleistungen", approach: "Ansatz", ibv: "IBV", investors: "Investoren", about: "Uber uns", contact: "Kontakt", requestCall: "Anruf Anfordern" },
    hero: { headline: "Wachstum Fordern", subhead: "Kapitalallokation, Umsatzsteigerung und institutionelle Markenbewertung.", cta1: "Sprechen Sie mit uns", cta2: "Dienste Ansehen", trust1: "Von Betreibern gefuhrt", trust2: "Institutionelle Qualitat", trust3: "Vertraulich und selektiv" }
  },
  it: {
    nav: { services: "Servizi", approach: "Approccio", ibv: "IBV", investors: "Investitori", about: "Chi Siamo", contact: "Contatto", requestCall: "Richiedi Accesso" },
    hero: { 
      badge: "Piattaforma di Investimento Attiva",
      headline: "Supporto agli Imprenditori",
      headlineAccent: "ad Alta Convinzione",
      subhead: "Struttura, disciplina ed esecuzione—applicati a ogni decisione.",
      supportingLine: "Non solo capitale. Prendiamo un ruolo attivo nella costruzione delle aziende che sosteniamo.",
      supportingText: "",
      cta1: "Richiedi Accesso",
      cta2: "I Nostri Servizi",
      ctaSubtext: "L'accesso è selettivo per design.",
      trustBullet1: "Partnership founder-first",
      trustBullet2: "Approccio di capitale attivo",
      trustBullet3: "Supporto orientato all'esecuzione",
      videoLabel: "La Nostra Metodologia",
      videoTitle: "Come Creiamo Valore",
      trustedPartner: "Partner Affidabile",
      since: "Dal 2026"
    },
    selectiveByDesign: {
      title: "Selettivi. Intenzionali. Allineati.",
      text: "Collaboriamo con un numero limitato di investitori per garantire focus, allineamento e performance."
    },
    whyItMatters: {
      title: "Strutturati per Performare. Costruiti per Scalare.",
      text1: "La maggior parte degli investimenti non fallisce per mancanza di opportunità,",
      text2: "ma per mancanza di struttura ed esecuzione.",
      text3: "Noi sistematizziamo entrambe.",
      bullet1Title: "Decision-Making Strutturato",
      bullet1Desc: "Framework chiari che eliminano il rumore e guidano azioni mirate.",
      bullet2Title: "Visibilità Continua sulla Performance",
      bullet2Desc: "Insights in tempo reale sulla salute del portfolio e le opportunità.",
      bullet3Title: "Supporto Attivo all'Esecuzione",
      bullet3Desc: "Coinvolgimento diretto che accelera i risultati."
    },
    differentiation: {
      title: "Non Solo Capitale.",
      titleAccent: "Un Vantaggio Strutturale.",
      cta: "Vedi Il Nostro Processo",
      discipline: {
        title: "Disciplina d'Investimento",
        description: "Ogni opportunità viene valutata rigorosamente secondo criteri d'investimento chiari prima di essere considerata."
      },
      execution: {
        title: "Esecuzione Attiva",
        description: "Supportiamo attivamente l'implementazione, il monitoraggio della performance e la creazione di valore."
      },
      alignment: {
        title: "Incentivi Allineati",
        description: "Investiamo al fianco dei nostri partner con rischio condiviso, upside condiviso e focus a lungo termine."
      }
    },
    vision: {
      title: "Strutturati per Performare. Costruiti per Scalare.",
      subtitle: "Combiniamo capitale, disciplina ed esecuzione per guidare sistematicamente la performance.",
      pillar1Title: "Chiarezza nelle Decisioni",
      pillar1Desc: "Identificare vincoli, definire priorità e costruire framework decisionali ad alta convinzione.",
      pillar2Title: "Creazione di Valore Operativa",
      pillar2Desc: "Progettare e implementare roadmap di esecuzione con incentivi allineati e responsabilità operativa.",
      pillar3Title: "Visibilità Totale sulla Performance",
      pillar3Desc: "Monitorare la performance continuamente con insight in tempo reale su crescita, rischi e opportunità."
    },
    team: {
      title: "Il Nostro Team",
      member1Role: "Founder & CEO - Head of Investments",
      member2Role: "Partner & Head of Execution and Operations"
    },
    stats: {
      stat1Value: "€10M+",
      stat1Label: "Capitale Impiegato",
      stat2Value: "25+",
      stat2Label: "Aziende in Portfolio",
      stat3Value: "3x",
      stat3Label: "Rendimenti Medi",
      stat4Value: "15+",
      stat4Label: "Anni di Esperienza",
      disclaimer: "Basato su engagement selezionati ed esposizione portfolio"
    },
    services: {
      badge: "Competenze Core",
      title: "Cosa Guida la Performance",
      subtitle: "Tre competenze che impattano direttamente i risultati degli investimenti.",
      learnMore: "Scopri di più",
      showLess: "Mostra meno",
      capital: {
        title: "Allocazione del Capitale",
        description: "Accesso a opportunità qualificate ad alta convinzione, supportate da framework d'investimento disciplinati.",
        tier1Name: "1. Investimento Attivo",
        tier1Desc: "Capitale con ruolo esecutivo diretto per guidare la crescita dall'interno.",
        tier2Name: "2. Investimento Non Attivo",
        tier2Desc: "Investimento equity senza coinvolgimento operativo, supervisione puramente finanziaria.",
        tier3Name: "3. High-Level Networking",
        tier3Desc: "Accesso a relazioni strategiche, deal flow e connessioni istituzionali per accelerare la performance."
      },
      revenue: {
        title: "Crescita dei Ricavi",
        description: "Implementiamo sistemi scalabili che impattano direttamente ricavi, margini e valutazione.",
        tier1Name: "1. Struttura Commerciale",
        tier1Desc: "Costruzione di team di vendita scalabili, ottimizzazione della pipeline e gestione strategica degli account.",
        tier2Name: "2. Revenue Management",
        tier2Desc: "Ottimizzazione di pricing e leve di ricavo per massimizzare la redditività.",
        tier3Name: "3. Struttura Operativa",
        tier3Desc: "Progettazione di framework operativi efficienti che supportano crescita sostenibile."
      },
      ibv: {
        title: "Valutazione Istituzionale del Brand",
        description: "Posizioniamo le aziende per soddisfare standard istituzionali e sbloccare multipli di valutazione più alti.",
        tier1Name: "1. Valutazione del Brand",
        tier1Desc: "Rafforzamento degli asset del brand e della percezione di mercato per aumentare la valutazione complessiva.",
        tier2Name: "2. Posizionamento Digitale",
        tier2Desc: "Ottimizzazione della visibilità e rilevanza del brand sui canali digitali.",
        tier3Name: "3. Scale-Up Istituzionale",
        tier3Desc: "Elevare la credibilità del brand per partnership istituzionali, M&A e round di finanziamento."
      }
    },
    portfolio: {
      subtitle: "Esposizione Corrente",
      title: "Opportunità d'Investimento Selezionate",
      cta: "Opportunità condivise dopo qualificazione",
      sectorNote: "Esposizione settoriale su mercati ad alta crescita.",
      sectors: {
        saas: "SaaS",
        fintech: "Fintech",
        healthcare: "Healthcare",
        foodtech: "Food Tech",
        ecommerce: "E-Commerce",
        mobility: "Mobilità"
      }
    },
    approach: {
      title: "Un Processo Disciplinato",
      subtitle: "METODOLOGIA",
      step1: { title: "Diagnosi", description: "Identificare vincoli, gap di posizionamento e reali opportunità di crescita." },
      step2: { title: "Struttura", description: "Definire una roadmap con milestone chiare e incentivi allineati." },
      step3: { title: "Esecuzione", description: "Implementare con coinvolgimento diretto e monitoraggio continuo della performance." }
    },
    testimonials: {
      subtitle: "Caso Selezionato",
      title: "Track Record di Performance",
      subtitleText: "Risultati da engagement selezionati.",
      testimonial1: {
        quote: "L'approccio strutturato e l'esecuzione diretta hanno contribuito a un risultato di valutazione significativamente superiore.",
        author: "CEO Azienda in Portfolio",
        role: "SaaS Growth-stage",
        company: ""
      },
      testimonial2: {
        quote: "La metodologia disciplinata ci ha aiutato a chiudere la Series B con una valutazione 3x superiore alle proiezioni iniziali.",
        author: "Managing Director",
        role: "Settore Tecnologico",
        company: ""
      },
      testimonial3: {
        quote: "Il volume di contratti enterprise è raddoppiato in 18 mesi attraverso un'esecuzione commerciale strutturata.",
        author: "Chief Operating Officer",
        role: "Software B2B",
        company: ""
      }
    },
    whoThisIsFor: {
      title: "Progettato per Investitori Selezionati",
      text: "Progettato per investitori che valorizzano struttura, selettività e performance rispetto al volume."
    },
    investors: {
      title: "Accesso Strutturato.",
      titleAccent: "Opportunità Qualificate.",
      subtitle: "PER INVESTITORI QUALIFICATI",
      punchyIntro: "Performance guidata da disciplina, esecuzione e deal flow proprietario — costruito per investitori che valorizzano chiarezza e risultati a lungo termine.",
      types: "Tipi di Investitori",
      typesIntro: "Lavoriamo selettivamente con partner qualificati nei seguenti profili:",
      typesList: ["Angel Investors", "Family Office", "Venture Capital", "Private Equity", "Partner Strategici"],
      ticket: "Commitment Tipico",
      ticketRange: "€25K – €50K",
      ticketSubtitle: "Strutture flessibili basate su opportunità e profilo investitore",
      ticketTransparency: "Strutturato per opportunità con piena trasparenza sull'utilizzo del capitale.",
      benefits: { 
        title: "Cosa Ricevono gli Investitori Qualificati", 
        item1: "Deal flow qualificato", 
        item2: "Due diligence rigorosa", 
        item3: "Termini di co-investimento strutturati",
        item4: "Visibilità portfolio in tempo reale",
        item5: "Accesso diretto alle opportunità",
        item6: "Standard di reporting istituzionale"
      },
      accessNote: "L'accesso viene concesso selettivamente dopo una qualificazione iniziale.",
      cta: "Richiedi Accesso"
    },
    clientPortal: {
      title: "I Tuoi Investimenti.",
      titleAccent: "Piena Visibilità.",
      subtitle: "Traccia performance, accedi ai documenti e monitora le opportunità in tempo reale.",
      feature1: "Dashboard Portfolio",
      feature2: "Centro Documenti",
      feature3: "Pipeline Deal",
      feature4: "Notifiche"
    },
    about: {
      title: "Costruiti per la Performance",
      subtitle: "CHI SIAMO",
      mission: "La Nostra Missione",
      missionText: "Combiniamo capitale, esecuzione operativa e posizionamento istituzionale per aiutare i founder a scalare — e gli investitori a raggiungere risultati superiori, corretti per il rischio.",
      values: "Principi Operativi",
      value1: "Integrità in ogni rapporto",
      value1Desc: "Operiamo con totale trasparenza verso founder, investitori e partner — nessun conflitto, nessuna scorciatoia.",
      value2: "Eccellenza nell'esecuzione",
      value2Desc: "Ogni engagement è tenuto a standard istituzionali. Non consigliamo — realizziamo.",
      value3: "Riservatezza per design",
      value3Desc: "Tutte le informazioni condivise nella nostra piattaforma sono trattate con stretta discrezione e salvaguardie strutturali.",
      principlesClosing: "Questi principi non sono aspirazionali — sono operativi."
    },
    team: {
      title: "Il Nostro Team",
      subtitle: "Le persone dietro il capitale, la strategia e l'esecuzione.",
      member1Role: "Founder & CEO, Head of Investments",
      member1Bio: "Imprenditore seriale e investitore con oltre 15 anni di esperienza nella costruzione e scaling di aziende in Europa e America Latina. Patricio guida deal sourcing, strutturazione del capitale e partnership strategiche.",
      member2Role: "Partner, Head of Execution and Operations",
      member2Bio: "Specialista in operazioni e crescita con profonda esperienza nel scaling di team commerciali, ottimizzazione delle strutture di revenue e costruzione di processi di livello istituzionale per aziende ad alta crescita."
    },
    finalCta: {
      title: "Richiedi Accesso",
      subtitle: "Un processo selettivo — collaboriamo solo con founder e investitori dove c'è genuino allineamento.",
      step1Title: "Invia il Tuo Profilo",
      step1Desc: "Raccontaci i tuoi obiettivi, background e cosa stai cercando.",
      step2Title: "Call di Qualificazione",
      step2Desc: "Una conversazione focalizzata per valutare allineamento e fit dell'opportunità.",
      step3Title: "Accesso Garantito",
      step3Desc: "Ricevi deal flow curato e accesso diretto al nostro network.",
      trustLine: "Le candidature vengono esaminate entro 5 giorni lavorativi. Tutte le informazioni sono trattate con stretta confidenzialità.",
      cta: "Richiedi Accesso",
      noCommitment: "Nessun impegno richiesto. L'accesso è selettivo per design."
    },
    faq: {
      subtitle: "Domande Frequenti",
      title: "FAQ",
      description: "Tutto quello che devi sapere per collaborare con HÜBNER Capital.",
      stillQuestions: "Hai ancora domande?",
      getInTouch: "Contattaci",
      q1: "A chi si rivolge Hübner Capital?",
      a1: "Lavoriamo con due gruppi distinti: founder ad alta convinzione che guidano business scalabili e necessitano di più del semplice capitale, e investitori qualificati alla ricerca di deal flow curato e disciplinato. Entrambi devono soddisfare i nostri criteri di qualificazione — siamo selettivi per design.",
      q2: "In quali tipi di aziende investite?",
      a2: "Ci focalizziamo su aziende in settori ad alta crescita — inclusi SaaS, Fintech, Healthcare, Food Tech, E-Commerce e Mobility — che hanno dimostrato product-market fit e sono pronte a scalare. Cerchiamo founder con chiarezza di visione e disciplina nell'esecuzione.",
      q3: "Cosa significa 'investimento attivo' in pratica?",
      a3: "A differenza dei fornitori di capitale passivo, assumiamo un ruolo operativo a fianco del founder. Questo significa coinvolgimento diretto nella struttura commerciale, revenue management e posizionamento istituzionale — non supervisione dal board a distanza, ma esecuzione hands-on con incentivi allineati.",
      q4: "Come funziona il processo di qualificazione?",
      a4: "Dopo aver inviato il tuo profilo, il nostro team esamina la candidatura entro 5 giorni lavorativi. Se c'è potenziale allineamento, programmiamo una call di qualificazione focalizzata. L'accesso alle opportunità e alle strutture di partnership viene concesso solo dopo il completamento di questo processo. Tutte le informazioni sono trattate con stretta confidenzialità.",
      q5: "Cos'è l'Institutional Brand Valuation (IBV) e perché è importante?",
      a5: "IBV è il nostro framework proprietario per posizionare le aziende secondo standard istituzionali — rafforzando credibilità del brand, visibilità digitale e percezione di mercato in modi che impattano direttamente i multipli di valutazione. Colma il gap tra un business forte e uno investibile.",
      q6: "Sono un investitore — cosa posso aspettarmi dopo la qualificazione?",
      a6: "Gli investitori qualificati ricevono accesso a deal flow curato che ha superato il nostro processo di due diligence interno, termini di co-investimento strutturati, visibilità portfolio in tempo reale e standard di reporting istituzionale. Non riceverai opportunità non richieste — tutto è abbinato al tuo profilo e preferenze.",
      q7: "È richiesto un commitment minimo?",
      a7: "I commitment tipici variano in base all'opportunità e al profilo dell'investitore. Le strutture sono flessibili e progettate intorno all'allineamento — non a soglie arbitrarie. Questo viene discusso durante il processo di qualificazione."
    },
    contact: {
      title: "Connettiamoci",
      subtitle: "CONTATTACI",
      tabInvestor: "Sono un Investitore",
      tabCompany: "Sono un'Azienda / Founder",
      form: {
        firstName: "Nome",
        lastName: "Cognome",
        email: "Email",
        phone: "Telefono",
        country: "Paese / Regione",
        language: "Lingua Preferita",
        linkedin: "URL LinkedIn",
        company: "Azienda / Organizzazione",
        role: "Ruolo / Titolo",
        message: "Messaggio / Note",
        investorType: "Tipo di Investitore",
        investmentFocus: "Focus di Investimento",
        ticketSize: "Ticket Size Tipico",
        investmentRange: "Range di Investimento per questa Opportunità",
        sectors: "Preferenze di Settore",
        geography: "Preferenza Geografica",
        timeHorizon: "Orizzonte Temporale",
        companyWebsite: "Sito Web Aziendale",
        revenue: "Range di Fatturato Annuale",
        teamSize: "Dimensione del Team",
        objective: "Obiettivo Principale",
        timeline: "Timeline Desiderata",
        budget: "Budget / Dimensione Engagement",
        consent: "Acconsento ad essere contattato riguardo questa richiesta",
        privacy: "Inviando questo modulo, accetti la nostra Privacy Policy e i Termini di Servizio.",
        submit: "Invia Richiesta",
        submitting: "Invio in corso...",
        successTitle: "Grazie",
        successMessage: "La tua richiesta è stata ricevuta. Ti contatteremo a breve.",
        bookCall: "Prenota una Chiamata"
      }
    },
    footer: { rights: "Tutti i diritti riservati.", privacy: "Privacy Policy", terms: "Termini di Servizio" }
  },
  ar: {
    nav: { services: "الخدمات", approach: "النهج", ibv: "IBV", investors: "للمستثمرين", about: "حولنا", contact: "اتصل بنا", requestCall: "طلب مكالمة" },
    hero: { headline: "تغذية النمو", subhead: "تخصيص رأس المال وتسريع الإيرادات وتقييم العلامة التجارية المؤسسية.", cta1: "تحدث معنا", cta2: "عرض الخدمات", trust1: "بقيادة المشغلين", trust2: "درجة مؤسسية", trust3: "سري وانتقائي" }
  },
  hi: {
    nav: { services: "सेवाएं", approach: "दृष्टिकोण", ibv: "IBV", investors: "निवेशकों के लिए", about: "हमारे बारे में", contact: "संपर्क", requestCall: "कॉल का अनुरोध करें" },
    hero: { headline: "विकास को बढ़ावा देना", subhead: "पूंजी आवंटन, राजस्व त्वरण और संस्थागत ब्रांड मूल्यांकन।", cta1: "हमसे बात करें", cta2: "सेवाएं देखें", trust1: "ऑपरेटर-नेतृत्व", trust2: "संस्थागत-ग्रेड", trust3: "गोपनीय और चयनात्मक" }
  },
  zh: {
    nav: { services: "服务", approach: "方法", ibv: "IBV", investors: "投资者", about: "关于我们", contact: "联系我们", requestCall: "请求通话" },
    hero: { headline: "推动增长", subhead: "资本配置、收入加速和机构品牌估值。", cta1: "与我们交谈", cta2: "查看服务", trust1: "运营商主导", trust2: "机构级", trust3: "保密且精选" }
  }
};

export const languages = [
  { code: 'es-es', name: 'Español', flag: 'ES' },
  { code: 'en', name: 'English', flag: 'EN' }
];

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  // Default to Spanish (es-es) instead of English
  let result = translations[lang] || translations['es-es'];
  for (const key of keys) {
    result = result?.[key];
    if (!result) {
      // Fallback to Spanish
      result = translations['es-es'];
      for (const k of keys) {
        result = result?.[k];
        if (!result) return path;
      }
      return result;
    }
  }
  return result;
};
